import { BaseEdge, EdgeProps, getStraightPath } from 'reactflow'

const VerticalCurveEdge = ({ id, sourceX, sourceY, targetX, targetY, markerEnd }: EdgeProps) => {
  const [path] = getStraightPath({ sourceX, sourceY, targetX, targetY })

  return (
    <>
      <BaseEdge id={id} path={path} style={{ strokeWidth: 1, stroke: 'black' }} markerEnd={markerEnd} />
    </>
  )
}

export default VerticalCurveEdge
